import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector: 'madero-error-page',
    imports: [],
    templateUrl: './error-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent implements OnInit {
  #route = inject(Router);
  #auth = inject(AuthService);

  ngOnInit(): void {
    setTimeout(() => {
      this.#auth.logOut().subscribe();
    }, 5000);
  }
}
